document.addEventListener("DOMContentLoaded", function () {
    const preloader = document.getElementById('preloader');
    if (preloader) {
        setTimeout(() => {
            preloader.style.opacity = '0';
            preloader.style.visibility = 'hidden';
            document.body.classList.remove('loading');
        }, 3000); // Adjust the duration as needed
    }
});
